
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 299 299","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M297.705 135.824c0-7.53-6.114-13.645-13.644-13.645H13.9c-7.53 0-13.645 6.114-13.645 13.645v27.29c0 7.53 6.114 13.644 13.645 13.644h270.16c7.531 0 13.645-6.114 13.645-13.645v-27.289z"}})])
          )
        }
      }
    